import { Card } from "antd";
import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import "../../../../App.css";
import { RightCircleOutlined, LeftCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  apiCallStatus,
  SetPreventiveData,
  getQuarterRange,
  getQuarterMonths,
} from "../actions/maintenanceDashboardService";
import {
  preventiveMaintenanceDataStatusData,
  doughnutOptions,
  doughnutChartCenterValue,
  renderStatusData,
  calculateYtdTotal,
} from "../constant/maintenanceConstantData";
import { PreventiveMaintenanceChildComponent } from "../maintenanceCommonComponent";

const PreventiveMaintenanceCard = ({
  handleChevronRightClick,
  setShowPreventiveMaintenanceCard,
  showPreventiveMaintenanceCard,
  searchedItem,
}) => {
  const [chartData, setChartData] = useState([]);
  const [pmpYtdTotal, setPmpYtdTotal] = useState([0]);
  const [openChartData, setOpenChartData] = useState([0]);
  const [closedChartData, setClosedChartData] = useState([0]);

  const dispatch = useDispatch();

  const {
    PmpEndDate: endDate,
    PmpStartDate: startDate,
    PmpChartData: pmpChartData,
    PmpYtdData: pmpYtdData,
  } = useSelector((state) => state?.maintenanceDashboardList);
  useEffect(() => {
    if (pmpChartData && pmpChartData.length > 0) {
      const sortedData = [...pmpChartData].sort(
        (a, b) => a.pmpStatusCode - b.pmpStatusCode
      );

      const data = sortedData.map((item) => item.total);

      setChartData(data);
      const pmpTotalCount = data.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      const pmpOpenCount = sortedData
        ?.filter((openData) => openData.pmpStatus !== "Completed")
        .reduce((acc, openDataValue) => acc + openDataValue.total, 0);

      setOpenChartData(pmpOpenCount);

      const pmpCloseCount = sortedData?.find(
        (closeData) => closeData.pmpStatus === "Completed"
      ).total;
      setClosedChartData(pmpCloseCount);
      const preventiveMaintenceScore =
        pmpTotalCount !== 0
          ? ((pmpCloseCount / pmpTotalCount) * 100).toFixed(2) + "%"
          : "0.00%";
      dispatch(apiCallStatus({ preventiveMaintenceScore }));
      const result = calculateYtdTotal(pmpYtdData);
      setPmpYtdTotal(result);
    }
  }, [pmpChartData, dispatch]);
  const labels = preventiveMaintenanceDataStatusData.map((item) => item.status);
  const backgroundColors = preventiveMaintenanceDataStatusData.map(
    (item) => item.color
  );
  const preventiveMaintenanceData = {
    labels: labels,
    datasets: [
      {
        data: chartData,
        backgroundColor: backgroundColors,

        borderWidth: 1,
      },
    ],
  };
  const preventiveMaintenanceOptions = {
    ...doughnutOptions,
  };

  const preventiveTextCenter = doughnutChartCenterValue("Total PMP");

  useEffect(() => {
    dispatch(
      SetPreventiveData({
        preventiveMaintenanceData,
        pmpYtdTotal,
      })
    );
  }, [openChartData,closedChartData]);

  const quarterMonths = getQuarterMonths(startDate, endDate);
  const pmpYear = getQuarterRange(quarterMonths, startDate, endDate);
  return (
    <Card
      className={
        showPreventiveMaintenanceCard ? "first-card-class" : "card-class"
      }
    >
      <div className={showPreventiveMaintenanceCard ? "card-main-div" : ""}>
        <div className="card-first-div">
          <h3 className="card-heading">Preventive Maintenance</h3>
          <div className="chart-main-div">
            <div className="doughnut-chart-div">
              <Doughnut
                data={preventiveMaintenanceData}
                options={preventiveMaintenanceOptions}
                plugins={[preventiveTextCenter]}
              />
            </div>
            <div className="asset-health-score-level">
              {renderStatusData(preventiveMaintenanceDataStatusData)}
            </div>
          </div>
          <div className="prevent-maintenance-icon-div">
            {showPreventiveMaintenanceCard ? (
              ""
            ) : (
              <span
                onClick={() => {
                  handleChevronRightClick("preventive-maintenance");
                }}
                className="right-circle-outlined-icon"
              >
                <RightCircleOutlined />
              </span>
            )}
          </div>
        </div>
        {showPreventiveMaintenanceCard && (
          <div className="showcard-card-class">
            <PreventiveMaintenanceChildComponent
              quarterMonths={quarterMonths}
              pmpOpenCount={openChartData}
              pmpCloseCount={closedChartData}
              pmpYear={pmpYear}
              pmpYtdTotal={pmpYtdTotal}
            />
            <div className="third-party-audit-icon-div">
              <span
                className="left-circle-outlined-icon"
                onClick={() =>
                  setShowPreventiveMaintenanceCard(
                    !showPreventiveMaintenanceCard
                  )
                }
              >
                <LeftCircleOutlined />
              </span>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default PreventiveMaintenanceCard;
